import React, {Fragment} from 'react';
import {Formik, Form, Field, ErrorMessage} from 'formik';
import {FormattedMessage} from 'react-intl';
import Yup from '../../yup';
import classNames from 'classnames';
import messages from '../../../res/translations/messages';
import Error from '../Error';
import Alert from '../Alert';
import Icon from '../Icon';
import LocaleOptions from './LocaleOptions';

const SurveyCreateSchema = Yup.object().shape({
    name: Yup.string().required(),
    locale: Yup.string().required(),
});

const SurveyCreateForm = ({item, error, saveCallback, onCancel}) => (
    <Formik
        initialValues={item || {
            name: '',
            locale: 'it-IT',
        }}
        validationSchema={SurveyCreateSchema}
        onSubmit={saveCallback}
    >
        {({values, errors, touched}) => (
            <Fragment>
                {error && <Alert error={error} />}
                <Form>
                    <div className="survey-create-box d-flex justify-content-between flex-wrap align-items-center flex-md-nowrap">
                        <div className="form-group col-md-3 col-sm-3">
                            <label className="col-form-label" htmlFor="name"><FormattedMessage {...messages.surveys.form.label.name} /></label>
                            <Field name="name" type="text" className="form-control" />
                            <ErrorMessage name="name">{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                        </div>
                        <div className="form-group col-md-3 col-sm-3">
                            <label className="col-form-label" htmlFor="locale"><FormattedMessage {...messages.surveys.form.label.locale} /></label>
                            <Field name="locale" component="select" placeholder="Select locale" className="form-control">
                                <LocaleOptions />
                            </Field>
                            <ErrorMessage name="locale">{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                        </div>
                        <div className="col text-right">
                            <button type="button" className={classNames('btn btn-outline-secondary btn-sm mr-3')} onClick={onCancel}>
                                <FormattedMessage {...messages.surveys.button.cancel} />
                            </button>
                            <button type="submit" className={classNames('btn btn-primary btn-sm')}>
                                <Icon icon="new-doc" /> <FormattedMessage {...messages.surveys.button.create} />
                            </button>
                        </div>
                    </div>
                </Form>
            </Fragment>
        )}
    </Formik>
);

export default SurveyCreateForm;
